import StatusPage from "../../../components/Status/StatusPage";

export default function Done() {

    /* render */

    return (
        <StatusPage
            badgeText="회원가입 완료"
            iconSrc="/svg/checkbox-filled.svg"
            iconAlt="complete"
            title="회원가입 신청이 완료되었습니다"
            descriptions={[
                "입력하신 정보와 제출 자료를 확인한 뒤 승인 절차가 진행됩니다.",
                "로그인 후 심사 상태를 확인할 수 있습니다.",
            ]}
            buttonText="로그인 하러가기"
            buttonTo="/signin"
        />
    );
}
